export const search = [
  { location: "/maquininha/my-terminals", name: "Maquininha" },
  { location: "/maquininha/extract", name: "Extrato maquininha" },
  { location: "/maquininha/my-terminals", name: "Terminais" },
  { location: "/maquininha/extract", name: "Extrato terminais" },
  { location: "/extract", name: "Extrato" },
  { location: "Pix", name: "Pix" },
  { location: "Pix", name: "Novo Pix" },
  { location: "pix/copy-and-paste", name: "Pagar" },
  { location: "pix/copy-and-paste", name: "Pix Copia e Cola" },
 // { location: "ChargeMenu", name: "Boletos" },
  //{ location: "Cards", name: "Cartões" },
  { location: "/pix/pix-and-transfers", name: "Transferir" },
  { location: "pix/new-qrcode", name: "Cobrar" },
  { location: "/wallet/security-devices", name: "Segurança" },
  { location: "/wallet/security-devices", name: "Dispositivos habilitados" },
  { location: "/wallet/security-devices", name: "Meus Dispositivos" },
  { location: "/security/habilited", name: "Dispositivos" },
  //{ location: "FullExtract", name: "Últimas transações" },
  { location: "pix/favorites", name: "Meus favoritos" },
  { location: "pix/new-qrcode", name: "Pix QR" },
  { location: "pix/copy-and-paste", name: "Copia e cola" },
  //{ location: "ViewMyData", name: "Agência e conta" },
  { location: "pix/favorites", name: "Favoritos" },
  //{ location: "PixPayScannerQrCode", name: "Ler QR" },
  { location: "pix/new-qrcode", name: "Gerar QR" },
  //{ location: "ScanBarcode", name: "Ler Boleto" },
  //{ location: "PayBillDigitableLine", name: "Digitar Boleto" },
  { location: "transfer-wallet/wallet-list", name: "Transferência entre contas" },
 // { location: "PixTransferAgency", name: "Transferir para outro banco" },
  // { location: "support/how", name: "Minhas senhas" },
  { location: "/", name: "Visualizar meus dados" },  
  // { location: "support/how", name: "Alterar Senha de Login" },
  { location: "configkeypasswordeletronic", name: "Alterar Senha Eletrônica" },
  { location: "configkeypasswordeletronic", name: "Senha Eletronica" },
  // { location: "support/how", name: "Esqueci meu PIN" },
  { location: "wallet/adds-founds-wallet ", name: "Depositar"},
  { location: "signout", name: "Sair",},
  //{ location: "DemandMenu", name: "Boleto PIX" },
  //{ location: "PayBillDigitableLine", name: "Boleto com linha digitável" },
  { location: "support", name: "Ajuda" },
  { location: "support", name: "Suporte" },
  { location: "/tax", name: "Minhas Tarifas" },
  { location: "/tax", name: "Tarifas" },


];
